<template>
  <div class="modal fade" id="BillRunLogs" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="BillRunLogsLabel">Bill run (Logs)</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x mt-1"
                          data-dismiss="modal"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <div class="table-responsive-lg tfh" v-if="log">
                  <b-table striped :items="log" :fields="BillRunLogsFields">
                    <template slot="Level" slot-scope="data">
                      <div
                        v-if="data.item.Level == 'Warning'"
                        class="bg-warning position-absolute brll"
                      >
                        <p class="fwfont font-weight-bold">{{data.item.Level}}</p>
                      </div>
                      <div
                        v-else-if="data.item.Level == 'Problem'"
                        class="bg-d position-absolute brll"
                      >
                        <p class="fwfont font-weight-bold">{{data.item.Level}}</p>
                      </div>
                      <div v-else>
                        <p class="fwfont font-weight-bold">{{data.item.Level}}</p>
                      </div>
                    </template>
                    <template slot="LoggedAt" slot-scope="data">{{data.item.LoggedAt | shortDate()}}</template>
                    <template slot="Reference" slot-scope="data">{{data.item.Reference}}</template>
                    <template slot="Details" slot-scope="data">
                      <p class="font-weight-bold d-inline">Message:</p>
                      <p style="white-space: pre-wrap;">{{data.item.Message}}</p>
                      <p class="font-weight-bold d-inline">Guidance:</p>
                      <p style="white-space: pre-wrap;">{{data.item.Guidance}}</p>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-12">
              <a
                class="btn btn-hc mr-2 float-right"
                :href="'https://' + this.logbot + '/api/v1/Messages/' + this.billRunId + '/export?token=' + accessToken + '&xsrf=' + xsrfToken"
              >Download</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//   import BillRunLogs from '@/json/logs.json'
import Vue from "vue";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      BillRunLogsFields: {
        Level: {
          label: "Level",
          class: "text-center position-relative no-pad"
        },
        LoggedAt: {
          label: "Logged At",
          class: "text-center"
        },
        Reference: {
          label: "Reference",
          class: "text-center"
        },
        Details: {
          Message: {
            label: "Message",
            class: "text-center"
          },
          Guidance: {
            label: "Guidance",
            class: "text-center"
          }
        }
      }
    };
  },
  computed: {
    log() {
      return this.$store.state.finances.billLogs;
    },
    billRunId() {
      return this.$store.state.customers.billRun.BillRunId;
    },
    logbot() {
      return Vue.config.honeycomb.logbot.domain;
    },
    details() {
      return this.$store.state.finances.runDetails;
    },
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    }
  }
};
</script>